module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body",
    on: {
      "dblclick": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left media-middle",
    attrs: {
      "title": _vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.TITLE
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: [_vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.CLASS, _vm.KomboxConf.ACLS[_vm.kombox.acl].SYMBOL.CLASS]
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body cc-kombox-body  media-middle"
  }, [(_vm.kombox.acl == 3) ? _c('strong', {
    attrs: {
      "title": _vm.kombox.content
    }
  }, [_vm._v("*******")]) : _c('strong', [_vm._v(_vm._s(_vm.kombox.content))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.kombox.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right text-right media-middle"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "btn btn-xs btn-default",
    class: {
      'btn-success': _vm.shippingAktive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickShipping
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-send"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29d60678!./~/vue-loader/lib/selector.js?type=template&index=0!./src/KomboxUserCallerColleague.vue
// module id = 265
// module chunks = 0